import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import {
	wrapperStyle,
	innerWrapperStyle,
	introTextStyle,
	titleStyle,
	bodyStyle,
} from 'inside-out/page-styles/static';

export default class PrivacyPolicyPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							heading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
						}).isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	render() {
		const { heading, body } = this.props.data.page.edges[0].node;

		return (
			<div className={wrapperStyle}>
				<Helmet title={heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={heading}/>
          <meta name="description" content="InsideOut Institute Privacy Policy Page"/>
          <meta property="og:description" content="InsideOut Institute Privacy Policy Page"/>
        </Helmet>

				<section className={innerWrapperStyle}>
					<div className={introTextStyle}>
						<h1 className={titleStyle}>{heading}</h1>
						<div className={bodyStyle} dangerouslySetInnerHTML={{ __html: body }} />
					</div>
				</section>
			</div>
		);
	}
}

export const query = graphql`
	query PrivacyPolicyPageQuery {
		page: allContentJson(filter: { id: { regex: "/content\\/privacy-policy-page\\.json/" } }) {
			edges {
				node {
					heading
					body
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/privacy-policy/index.js